<template>
  <ul class="expansion-panels">
    <slot />
  </ul>
</template>

<script lang="ts">
export type ParentState = {
  active: {
    [key: string]: boolean
  }
}

export default {
  name: 'ExpansionPanels',
}
</script>

<script setup lang="ts">
import { provide, ref, watch } from 'vue'
const state = ref<ParentState>({
  active: {},
})

// eslint-disable-next-line vue/define-emits-declaration
const emit = defineEmits(['update:active'])

provide<ParentState>('expansionPanelsState', state.value)

watch(state.value.active, (value) => {
  emit('update:active', value)
})
</script>

<style lang="scss" scoped>
.expansion-panels {
  display: flex;
  flex-direction: column;
  list-style: none;
  margin: 0;
  padding: 0;
  padding-bottom: 8px;
}
</style>
